<template>
  <section
    v-if="variant === variants.v1"
    class="layout-pt-lg special-colors layout-pb-lg"
    :style="`background-color: var(--c-${vars.backgroundColor}); color: var(--c-${vars.textColor})`"
  >
    <div class="container tw-flex tw-w-full tw-flex-col tw-items-center tw-justify-center tw-gap-12">
      <div
        class="tw-flex tw-w-full tw-flex-col tw-items-center tw-justify-center tw-gap-10 tw-text-start lg:tw-gap-20"
        :class="vars.isReversed ? 'lg:tw-flex-row-reverse' : 'lg:tw-flex-row'"
      >
        <div class="tw-relative tw-w-full lg:tw-w-1/2" style="aspect-ratio: 16/9">
          <library-iframe v-if="vars.videoUrl && !vars.photoImage" :h-ratio="9" :w-ratio="16" :src="vars.videoUrl" />
          <library-image :h-ratio="9" :w-ratio="16" v-if="vars.photoImage" :src="vars.photoImage"></library-image>
        </div>
        <div class="tw-flex tw-w-full tw-flex-col tw-items-start tw-justify-center tw-gap-6 tw-text-start lg:tw-w-1/2">
          <h2>{{ vars.titleText }}</h2>
          <p>{{ vars.descriptionText }}</p>
          <div
            class="tw-flex tw-w-full tw-flex-col tw-items-start tw-justify-center tw-gap-4 md:tw-mt-4 md:tw-flex-row md:tw-justify-start md:tw-gap-10"
          >
            <nuxt-link v-for="button in buttons" :to="button.link" :class="`n-${button.type}`">
              {{ button.label }}
              <span v-if="button.type === 'arrow'"
                ><svg width="23" height="8" viewBox="0 0 23 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M22.3536 4.35355C22.5488 4.15829 22.5488 3.84171 22.3536 3.64645L19.1716 0.464466C18.9763 0.269204 18.6597 0.269204 18.4645 0.464466C18.2692 0.659728 18.2692 0.976311 18.4645 1.17157L21.2929 4L18.4645 6.82843C18.2692 7.02369 18.2692 7.34027 18.4645 7.53553C18.6597 7.7308 18.9763 7.7308 19.1716 7.53553L22.3536 4.35355ZM0 4V4.5H22V4V3.5H0V4Z"
                    fill="#8FBB54"
                  />
                </svg>
              </span>
            </nuxt-link>
          </div>
        </div>
      </div>

      <div class="tw-w-full">
        <Swiper
          @slideChange="onSlideChange"
          :pagination="false"
          :space-between="24"
          :loop="false"
          :clickable="true"
          :breakpoints="{
            320: {
              slidesPerView: 1,
            },
            768: {
              slidesPerView: 2,
            },
            1024: {
              slidesPerView: 3,
            },
          }"
          @swiper="onSwiper"
          class="tw-w-full"
        >
          <SwiperSlide v-for="card in cards" :key="`card-${card.title}`" class="!tw-h-auto">
            <div class="tw-flex tw-h-full tw-flex-col tw-gap-6 tw-border tw-p-7" style="border-color: var(--c-border)">
              <div class="tw-h-24 tw-w-24">
                <library-image
                  :h-ratio="1"
                  :w-ratio="1"
                  :src="card.icon"
                  :alt="card.title"
                  image-class="!tw-object-contain"
                />
              </div>
              <h5>{{ card.title }}</h5>
              <p>{{ card.description }}</p>
            </div>
          </SwiperSlide>
        </Swiper>

        <div v-if="cards.length > 3" class="tw-mt-6 tw-hidden lg:tw-block">
          <LibrarySliderPagination
            :swiper="swiper"
            variant="v9"
            :can-paginate-back="canPaginateBack"
            :can-paginate-next="canPaginateNext"
            :variables="vars"
          />
        </div>
        <div v-if="cards.length > 2" class="tw-mt-6 tw-block md:tw-hidden">
          <LibrarySliderPagination
            :swiper="swiper"
            variant="v9"
            :can-paginate-back="canPaginateBack"
            :can-paginate-next="canPaginateNext"
            :variables="vars"
          />
        </div>
        <div v-if="cards.length > 1" class="tw-mt-6 tw-hidden md:tw-block lg:tw-hidden">
          <LibrarySliderPagination
            :swiper="swiper"
            variant="v9"
            :can-paginate-back="canPaginateBack"
            :can-paginate-next="canPaginateNext"
            :variables="vars"
          />
        </div>
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import { ComponentMixin } from '~/mixins/component.mixin';

export default defineNuxtComponent({
  name: 'Theme7MergedValues',

  mixins: [ComponentMixin],

  data() {
    return {
      variants: {
        v1: 'v1',
      },
      swiper: null,
      canPaginateBack: true,
      canPaginateNext: true,
    };
  },

  mounted() {
    this.onSlideChange();
  },

  computed: {
    cards() {
      return this.groupedVariables.cards;
    },

    buttons() {
      return this.groupedVariables.buttons;
    },
  },

  methods: {
    onSwiper(swiper) {
      this.swiper = swiper;
    },

    onSlideChange() {
      if (!this.swiper) return;
      const isAtStart = this.swiper.isBeginning;
      const isAtEnd = this.swiper.isEnd;
      if (isAtStart) this.canPaginateBack = false;
      else this.canPaginateBack = true;
      if (isAtEnd) this.canPaginateNext = false;
      else this.canPaginateNext = true;
    },
  },
});
</script>
